module.exports = __webpack_public_path__ + "assets/rider-app-black.2cd78d5f.svg";